import { render, staticRenderFns } from "./ContactSupportForm.vue?vue&type=template&id=090cb489&"
import script from "./ContactSupportForm.vue?vue&type=script&lang=js&"
export * from "./ContactSupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheInput: require('/opt/build/repo/components/basics/TheInput.vue').default,PromiseButton: require('/opt/build/repo/components/basics/PromiseButton.vue').default,TheModal: require('/opt/build/repo/components/basics/TheModal.vue').default})
